import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

export const useStore = create(
  devtools(
    persist(
      (set) => ({
        chosenPackage: null,
        contactInfo: {
          firstName: "",
          lastName: "",
          email: "",
          mobilePhone: "",
          address: null,
          unitNumber: "",
        },
        addressObject: null,
        scheduleData: {
          scheduleType: null,
          chosenDay: null,
          chosenTime: null,
        },
        fieldRoutesCustomer: null,
        stripeData: null,
        cardDetails: null,
        setChosenPackage: (pkg) => set({ chosenPackage: pkg }),
        setContactInfo: (info) => set({ contactInfo: info }),
        setAddressObject: (address) => set({ addressObject: address }),
        setScheduleData: (data) => set({ scheduleData: data }),
        setStripeData: (data) => set({ stripeData: data }),
        setFieldRoutesCustomer: (data) => set({ fieldRoutesCustomer: data }),
        setCardDetails: (data) => set({ cardDetails: data }),
        resetState: () =>
          set({
            chosenPackage: null,
            contactInfo: {
              firstName: "",
              lastName: "",
              email: "",
              mobilePhone: "",
              address: null,
              unitNumber: "",
            },
            addressObject: null,
            scheduleData: {
              scheduleType: null,
              chosenDay: null,
              chosenTime: null,
            },
            fieldRoutesCustomer: null,
            stripeData: null,
            cardDetails: null,
          }),
      }),
      {
        name: "magna-pest-store",
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
